import React, { Component } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from './Modal';
import { VideoListItem } from './VideoListItem';

export default class Video extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			loading: true,
			isModalOpen: false,
			videos: [],
			videoData: [],
			selectedVideo: null
		};
	}

	componentDidMount() {
		this.getVideoData();
	}
	
	toggleModal = () => {
		this.setState({
			isModalOpen: !this.state.isModalOpen
		});
	}

	getVideoData = () => {
		let videoData = [
			{
				id: '051719',
				videoTitle: 'Couponology Corner Introduction',
				videoDate: 'May 17, 2019',
				isIntro: true,
				isYouTube: false,
				altVideoURL: 'https://cdn.couponology.com/images/Couponology_Clips_Intro.mp4',
				altThumbnail: 'https://cdn.couponology.com/images/Couponology_Clips_Intro_Thumbnail.jpg'
			},
			{
                id: '5444834',
                videoTitle: "Back to School Deals with Couponology - ABC7 Chicago",
				videoDate: 'Aug 5, 2019',
				isIntro: false,
                isYouTube: false,
                altVideoURL: 'https://abc7chicago.com/video/embed/?pid=5444834',
                altThumbnail: 'https://cdn.abcotvs.com/dip/images/5444832_080519-wls-wcl-back-to-school-deals-vid.jpg'
            },
            {
                id: '5276244',
                videoTitle: "Mother's Day Gift Deals from Couponology - ABC7 Chicago",
				videoDate: 'Apr 29, 2019',
				isIntro: false,
                isYouTube: false,
                altVideoURL: 'https://abc7chicago.com/video/embed/?pid=5276244',
                altThumbnail: 'https://cdn.abcotvs.com/dip/images/5276243_042919-wcl-couponology-vid.jpg'
            },
            {
                id: '4873651',
                videoTitle: 'Holiday Gift Deals from Couponology - ABC7 Chicago',
				videoDate: 'Dec 10, 2018',
				isIntro: false,
                isYouTube: false,
                altVideoURL: 'https://abc7chicago.com/video/embed/?pid=4873651',
                altThumbnail: 'https://cdn.abcotvs.com/dip/images/4873650_121018-wcl-couponology-vid.jpg'
            },
            {
                id: '4488303',
                videoTitle: 'Check This Out - Couponology - ABC13 Houston',
				videoDate: 'Oct 15, 2018',
				isIntro: false,
                isYouTube: false,
                altVideoURL: 'https://abc13.com/video/embed/?pid=4488303',
                altThumbnail: 'https://cdn.abcotvs.com/dip/images/4488302_101518-ktrk-CTO1018A04-vid.jpg?w=800'
            },
			{
				id: 'ntH-MFUpaJY',
				videoTitle: 'Get Countless Deals at Your Fingertips with Couponology - ABC7 Bay Area',
				videoDate: 'Sep 22, 2018',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: 'bNzg_UfLfWA',
				videoTitle: 'Exclusive Mother\'s Day Deals from Couponology',
				videoDate: 'Apr 23, 2018',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: 'NPhzcEyTjyY',
				videoTitle: 'Fashion Week Couponology Corner on NBC\'s New York Live',
				videoDate: 'Sep 6, 2013',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: 'scLoAtc5l5E',
				videoTitle: 'Free Shipping Day on NBC\'s New York Live: Couponology Corner',
				videoDate: 'Dec 19, 2013',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: 'pJtsjCKZW44',
				videoTitle: 'Couponology Corner: Variety',
				videoDate: 'May 17, 2012',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: '0Ptj1WvH0kI',
				videoTitle: 'Couponology Corner: Health & Beauty',
				videoDate: 'Sep 26, 2012',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			},
			{
				id: '9oG5NPWHTrA',
				videoTitle: 'Couponology Corner on PIX11',
				videoDate: 'Apr 12, 2012',
				isIntro: false,
				isYouTube: true,
				altVideoURL: '',
				altThumbnail: ''
			}
		];

		this.setState({
			loading: false,
			videos: videoData,
			selectedVideo: videoData[0]
		});
	}

	renderVideoSection(videos, selectedVideo) {
		let Videos = videos;
		let SelectedVideo = selectedVideo;

		let interval = 4; // How many pixels at a time to scroll left or right on mouse clicks

        function checkForChrome() {
            return navigator.userAgent.match(/Chrome/i);
        }

        // On scrolling with by touch swiping, determine whether left or right scroll button should be visible based on position of scrollable content
        function btnDisplay(container, leftBtn, rightBtn) {
            let _container = document.getElementsByClassName(container)[0];
            let _leftBtn = document.getElementsByClassName(leftBtn)[0];
            let _rightBtn = document.getElementsByClassName(rightBtn)[0];
            if (_container.scrollLeft > 0 && _container.scrollLeft < _container.scrollWidth - _container.offsetWidth) {
                _leftBtn.style.display = 'inline-block';
                _rightBtn.style.display = 'inline-block';
            } else if (_container.scrollLeft === 0 && checkForChrome()) {
                _leftBtn.style.display = 'none';
            } else if (checkForChrome()) {
                _rightBtn.style.display = 'none';
            }
        }

        // Smooth scroll content to the left based on timing set by let interval = x
        function LeftClick(container, leftBtn, rightBtn) {
            let _container = document.getElementsByClassName(container)[0];
            let _leftBtn = document.getElementsByClassName(leftBtn)[0];
            let _rightBtn = document.getElementsByClassName(rightBtn)[0];
            let position = 0;
            let timer = setInterval(moveLeft, 1);
            function moveLeft() {
                if (position >= Math.ceil(_container.offsetWidth * .95) - 2 && position <= Math.floor(_container.offsetWidth * .95) + 2) {
                    clearInterval(timer);
                } else {
                    position += interval;
                    _container.scrollLeft -= interval;
                    _rightBtn.style.display = 'inline-block';
                    if (_container.scrollLeft === 0 && checkForChrome()) {
                        _leftBtn.style.display = 'none';
                    }
                }
            }
        }

        // Smooth scroll content to the right based on timing set by let interval = x
        function RightClick(container, leftBtn, rightBtn) {
            let _container = document.getElementsByClassName(container)[0];
            let _leftBtn = document.getElementsByClassName(leftBtn)[0];
            let _rightBtn = document.getElementsByClassName(rightBtn)[0];
            let position = 0;
            let timer = setInterval(moveRight, 1);
            function moveRight() {
                if (position >= Math.ceil(_container.offsetWidth * .95) - 2 && position <= Math.floor(_container.offsetWidth * .95) + 2) {
                    clearInterval(timer);
                } else {
                    position += interval;
                    _container.scrollLeft += interval;
                    _leftBtn.style.display = 'inline-block';
                    if (_container.scrollLeft >= _container.scrollWidth - _container.offsetWidth && checkForChrome()) {
                        _rightBtn.style.display = 'none';
                    }
                }
            }
        }

		const modalContent = <SimpleBar className='modal-content-container'>
													<div className='row'>
														<div className='col-xs-12'>
															<div className='video content'>
																{SelectedVideo.isYouTube ?
																	<iframe src={'https://www.youtube.com/embed/' + SelectedVideo.id} className="embedded-video" title='Embedded Video' allowFullScreen scrolling='no' frameBorder='0'></iframe> :
																		SelectedVideo.isIntro ?
																			<video 
																				className="embedded-video"
																				controls 
																				autoPlay
																				src={SelectedVideo.altVideoURL} 
																				type='video/mp4'
																			>
																			</video> :
																			<iframe src={SelectedVideo.altVideoURL} className='embedded-video' title='Embedded Video' allowFullScreen scrolling='no' frameBorder='0'></iframe>
																}
															</div>
														</div>
													</div>
													<div className='row'>
														<div className='col-md-12 video-list-container content'>
															<div className='scroll-wrapper'>
																	<div className='no-scroll-bar'>
																			<ul className='video-list container-1' onScroll={() => btnDisplay('container-1', 'left-btn-1', 'right-btn-1')}>
																					{Videos.map((video) =>
																							<VideoListItem
																									key={video.id}
																									videoURL={'https://www.youtube.com/embed/' + video.id}
																									videoThumbnail={'https://i.ytimg.com/vi/' + video.id + '/hqdefault.jpg'}
																									isYouTube={video.isYouTube}
																									altVideoURL={video.altVideoURL}
																									altThumbnail={video.altThumbnail}
																									videoTitle={video.videoTitle}
																									videoDate={video.videoDate}
																									video={video}
																									onVideoSelect={selectedVideo => this.setState({ selectedVideo })}
																							/>
																					)}
																			</ul>
																	</div>
																	<button className='left-btn left-btn-1' type='button' onClick={() => LeftClick('container-1', 'left-btn-1', 'right-btn-1')}></button>
																	<button className='right-btn right-btn-1' type='button' onClick={() => RightClick('container-1', 'left-btn-1', 'right-btn-1')}></button>
															</div>
														</div>
													</div>
												</SimpleBar>

		return (
			<div className='row min-height-400 border' id='video'>
				<div className='col-md-12 text-center'>
					<h1 className='section-heading'>Video &amp; TV</h1>
				</div>
				<div className='col-md-5 component-content-left'>
					<h2>
						Ready, Set, Action
					</h2>
					<p>
						Take a peek at our collection of Couponology Corner television segments. These videos showcase product deals and offers that air live on popular TV networks in major US markets.
					</p>
					<div className='btn-container'>
						<button className='btn-1' onClick={this.toggleModal.bind(this)}>view clips</button>
					</div>
					{this.state.isModalOpen ? 
						<Modal
							text={modalContent}
							open={this.state.isModalOpen}
							onClose={this.toggleModal.bind(this)}
						/> : ''}
				</div>
				<div className='col-md-7'>
					<div className='vlog-video-container'>
						<img src='https://cdn.couponology.com/images/mediakit-vlog-placeholder.png' alt='vlog placeholder' />
					</div>
				</div>
			</div>
		);
	}

	render() {
		let VideoSection = this.state.loading
            ? ''
            : this.renderVideoSection(this.state.videos, this.state.selectedVideo);
		return(
			<div>
				{VideoSection}
			</div>
		);
	}
}